module.exports = __webpack_public_path__ + "assets/img/img-tutorial02.00b0b23d.png";